import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { registerCheckList, registerList } from '@lexical/list';

export default function ListPlugin(): JSX.Element | null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const unregisterList = registerList(editor);
    const unregisterCheckList = registerCheckList(editor);

    return () => {
      unregisterList();
      unregisterCheckList();
    };
  }, [editor]);

  return null;
}